import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maintenanceCheck'
})
export class MaintenanceCheckPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    //console.log(args,"===================================================================");
    if(args.type == 'maintenance'){
      if((args.post.permissionToEnter == true && args.manager == "true") || (args.post.permissionToEnter == true && args.maintenance == "true")){
        return true;
      }else{
        if(args.post.permissionToEnter == false){
          return true;
        }else{
          return false;
        }
      }

    }else{
      return true;
    }

  }

}
